import { createStyles } from '../../../../../../../../../styles/helpers'
import { red } from '../../../../../../../../../styles/const/colors'

export default createStyles({
  textCommon: {
    wordBreak: 'break-word'
  },
  assetId: {
    extend: 'textCommon',
    marginBottom: 4
  },
  customLabel: {
    marginTop: 4
  },
  name: {
    extend: 'textCommon',
    fontWeight: 600
  },
  isInvalid: {
    color: red
  }
})
